import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookItem } from 'webhooks/shared/entities'

import { useMutationRequest } from '~/ui/hooks/utils'

interface PutWebhookSettingVariables {
  url?: string
  events?: string[]
  status?: number
  retry?: { maxAttempts: number; type: string }
  authentication?: { type: string; username?: string; password?: string }
  [key: string]: unknown
}

export function usePutWebhookSetting(paymentProfileId: string | undefined, webhookId: string) {
  return useMutationRequest<WebhookItem, unknown, false, PutWebhookSettingVariables>(
    ['usePutWebhookSetting', paymentProfileId, webhookId],
    data =>
      httpClientVendasCoreBff<WebhookItem>({
        url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings/${webhookId}`,
        method: 'PUT',
        data
      })
  )
}
